import clsx from "clsx";
import { Fragment } from "react";

import { RenderWhen } from "../../../../../../components";
import { DroppableRow, EmptyDroppableRow } from "../droppable";
import { SvgLayoutBlock } from "../layout-blocks";

import { getComponents } from "../../consts";
import { useGridRowsContext } from "../../hooks";
import styles from "./canvas.module.scss";
import { NEW_LAYOUT_CONTAINER_ID } from "./consts";

type Props = {
  onRemove: (id: string) => void;
};

const Canvas = ({ onRemove }: Props) => {
  const { canvasRows } = useGridRowsContext();
  return (
    <main id="canvas-wrapper" className={clsx(styles.canvas)}>
      <RenderWhen
        condition={Boolean(canvasRows?.length)}
        fallback={
          <DroppableRow id={NEW_LAYOUT_CONTAINER_ID}>
            <div className={styles.empty}>
              Drag and drop data blocks to create new layout.
            </div>
          </DroppableRow>
        }
      >
        {canvasRows.map((row, index) => (
          <Fragment key={`droppable-${row.components.join("-")}`}>
            <EmptyDroppableRow
              id={`new-layout-container-${index}`}
              index={index}
            />
            <DroppableRow
              id={`layout-container-${index}`}
              index={index}
              items={row.components}
            >
              {row.components.map(c => {
                const component = getComponents()[c];
                return (
                  <SvgLayoutBlock
                    className={styles[`component_${component.id}`]}
                    key={component.id}
                    id={component.id}
                    name={component.id}
                    title={component.title}
                    width={component.width}
                    onRemove={onRemove}
                  />
                );
              })}
            </DroppableRow>
          </Fragment>
        ))}
        <EmptyDroppableRow id={NEW_LAYOUT_CONTAINER_ID} />
      </RenderWhen>
    </main>
  );
};

export default Canvas;
